import React from "react";
import { MDBBtn } from "mdbreact";
import cx from "classnames";
import styles from "./style.module.scss";
class PKHBtn extends React.PureComponent {
  render() {
    const {
      outline,
      groupBtnInput,
      active,
      cancel,
      color,
      children,
      icon,
      onClick,
      row,
      column,
      prev,
      reset,
      next,
      create,
      create_patient_form,
      remove,
      edit,
      menu,
      back,
      back_navbar,
      payment,
      choose,
      block,
      disabled,
      small,
      login,
      downloadApp,
      google,
      facebook,
      email,
      phone,
      nextStep,
      buttonArrow,
      print_bill,
      confirm,
      close,
      classNameBtn,
      chosen,
      pd35 = false,
      fullWidthBtn,
      marginElement,
      customFont,
      tabIndex,
      hidden,
      className,
      iconPosition = "left",
      rounded,
      paddingCus,
      smallCus
    } = this.props;
    return (
      <MDBBtn
        style={{ padding: paddingCus }}
        disabled={!!disabled}
        flat={!color}
        color={color}
        onClick={onClick}
        className={cx(
          className,
          styles.button,
          styles[classNameBtn],
          hidden ? "d-none" : "",
          {
            [styles.cancel]: cancel,
            [styles.menu]: menu === "menu",
            [styles.back]: back === "back",
            [styles.back_navbar]: back_navbar === "back_navbar",
            [styles.row]: row === "row",
            [styles.column]: column === "column",
            [styles.next]: next === "next",
            [styles.prev]: prev === "prev",
            [styles.create_patient_form]:
              create_patient_form === "create_patient_form",
            [styles.reset]: reset === "reset",
            [styles.create]: create === "create",
            [styles.remove]: remove === "remove",
            [styles.print_bill]: print_bill === "print_bill",
            [styles.edit]: edit === "edit",
            [styles.close]: close === "close",
            [styles.confirm]: confirm === "confirm",
            [styles.payment]: payment === "payment",
            [styles.block]: block === "block",
            [styles.choose]: choose === "choose",
            [styles.small]: small === "small",

            [styles.smallCus]: smallCus,

            [styles.login]: login === "login",
            [styles.google]: google === "google",
            [styles.facebook]: facebook === "facebook",
            [styles.email]: email === "email",
            [styles.phone]: phone === "phone",
            [styles.downloadApp]: downloadApp,
            [styles.buttonArrow]: buttonArrow,
            [styles.chosen]: chosen === "chosen",
            [styles.pd35]: pd35,
            [styles.fullWidthBtn]: fullWidthBtn === "fullWidthBtn",
            [styles.customFont]: customFont === "customFont",
            [styles.marginElement]: marginElement === "marginElement",
            [styles.active]: active === "active",
            [styles.groupBtnInput]: groupBtnInput,
            [styles.outline]: outline,
            [styles.rounded]: rounded
          }
        )}
        tabIndex={tabIndex}
      >
        {(iconPosition === "left" && icon) || ""}
        <div>
          {children}
          {nextStep && <i className="fal fa-long-arrow-right" />}
          {downloadApp && <i className="far fa-arrow-to-bottom" />}
        </div>
        {iconPosition === "right" && icon}
      </MDBBtn>
    );
  }
}

export default PKHBtn;
